// See https://visawiki.trusted.visa.com/pages/viewpage.action?pageId=297137004 for more information
export const ACCT_INACCESSIBLE = 'ACCT_INACCESSIBLE';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_INVALID = 'AUTH_INVALID';
export const CARD_ADD_FAILED = 'CARD_ADD_FAILED';
export const CONSUMER_ID_MISSING = 'CONSUMER_ID_MISSING';
export const DPA_ID_MISSING = 'DPA_ID_MISSING';
export const FRAUD = 'FRAUD';
export const ID_FORMAT_UNSUPPORTED = 'ID_FORMAT_UNSUPPORTED';
export const INVALID_PARAMETER = 'INVALID_PARAMETER';
export const INVALID_REQUEST = 'INVALID_REQUEST';
export const NOT_FOUND = 'NOT_FOUND';
export const OTP_SEND_FAILED = 'OTP_SEND_FAILED';
export const RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED';
export const REQUEST_TIMEOUT = 'REQUEST_TIMEOUT';
export const REQUIRED_CVV = 'REQUIRED_CVV';
export const REQUIRED_VISA_OTP = 'REQUIRED_VISA_OTP';
export const SERVER_ERROR = 'SERVER_ERROR';
export const SERVICE_ERROR = 'SERVICE_ERROR';
export const SRCI_ID_MISSING = 'SRCI_ID_MISSING';
export const SRCI_TXN_ID_MISSING = 'SRCI_TXN_ID_MISSING';
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
export const VALDATA_MISSING = 'VALDATA_MISSING';
export const VALIDATION_DATA_MISSING = 'VALIDATION_DATA_MISSING';
